




































































import Vue from 'vue'
import {
  DxColumn,
  DxColumnChooser, DxFilterRow,
  DxHeaderFilter, DxLookup, DxRowDragging, DxScrolling,
  DxSearchPanel,
  DxSelection, DxSorting, DxStateStoring,
  DxTreeList
} from 'devextreme-vue/tree-list'
import { hexToRgba } from '@/services/hex-to-rgba'

interface ComponentData {
  gridData: any[]
  selectedRow: any | null
}

export default Vue.extend({
  name: 'ProjectPartsListDetailDialog',

  components: {
    DxTreeList,
    DxColumn,
    DxColumnChooser,
    DxHeaderFilter,
    DxSearchPanel,
    DxSelection,
    DxLookup,
    DxSorting,
    DxFilterRow,
    DxStateStoring,
    DxScrolling,
    DxRowDragging,
  },

  props: {
    show: {
      type: Boolean,
      default: false
    },
  },

  data (): ComponentData {
    return {
      gridData: [],
      selectedRow: null
    }
  },

  watch: {

  },

  computed: {
    toolbarColor (): string {
      return hexToRgba(this.$vuetify.theme.themes.light.primary)
    },
  },

  methods: {
    onCloseButtonClick (): void {
      this.$emit('close')
    },

    onPrintClick (): void {

    },

    onOpenClick (): void {
      //@ts-ignore
      this.$refs.dataGrid.instance.option("expandedRowKeys", [])
      //@ts-ignore
      this.$refs.dataGrid.instance.option("autoExpandAll", true)
    },

    onCloseClick (): void {
      //@ts-ignore
      this.$refs.dataGrid.instance.option("expandedRowKeys", [])
      //@ts-ignore
      this.$refs.dataGrid.instance.option("autoExpandAll", false)
    },

    onRowClick (data: any): void {
      const foundRow: any | undefined = this.gridData.find((item: any) => item.id === data.data.id)
      if(foundRow) {
        this.selectedRow = foundRow
      }
    },
  },

  mounted () {
    this.gridData = [
      {id: 1, parentId: null, value1: '001', value2: 'DL-A007 - Pro Zugang'},
      {id: 11, parentId: 1, value1: '001-1', value2: 'DL-A007 - Pro Zugang'},
      {id: 12, parentId: 1, value1: '001-2', value2: 'DL-A007 - Pro Zugang'},
      {id: 2, parentId: null, value1: '002', value2: 'DL-A011 - Mehraufwand Rampenfahrt'},
      {id: 3, parentId: null, value1: '003', value2: 'DL-A012 - Mehraufwand Rampenfahrt'},
      {id: 31, parentId: 3, value1: '003-1', value2: 'DL-A012 - Mehraufwand Rampenfahrt'},
      {id: 32, parentId: 3, value1: '003-2', value2: 'DL-A012 - Mehraufwand Rampenfahrt'},
    ]
  }
})
